<script setup>
import { getNewsById, getLogged, avatarUrl } from '@/services/api.js'
import { trackEvent } from '@/services/analytics.js'
import CommentItem from '@/components/comment.vue'
import CommentsItem from '@/components/comments.vue'
import ItemPerfil from '@/components/modals/perfil.vue'
import Sk from '@/components/usefulness/Sk.vue'
import ClientOnly from '@/components/ClientOnly.vue'
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/stores/index.js'
import { usePageDataStore } from '@/stores/pageData.js'

const store = useStore()
const pageData = usePageDataStore()
const route = useRoute()
const router = useRouter()

const id = ref(route.params.id)
const img = ref('')
const titulo = ref('')
const text = ref('')
const autor = ref('')
const time = ref('')
const user = ref('')
const perfilName = ref('')
const showP = ref(false)
const loading = ref(true)

function applyNews(data) {
  text.value = data.texto
  titulo.value = data.titulo
  autor.value = data.autor
  img.value = data.img
  time.value = data.time
  loading.value = false
}

async function getNews() {
  loading.value = true
  const cached = pageData.news
  if (cached && String(cached.id) === String(id.value)) {
    applyNews(cached)
    return
  }

  const data = await getNewsById(id.value)

  if (!data[0].error) {
    applyNews(data[0])
    trackEvent('view_news', { item_id: String(id.value) })
  } else if (import.meta.env.SSR) {
    loading.value = false
  } else {
    alert(data[0].text)
    await router.push({ path: '/error' })
  }
}

async function logado() {
  const data = await getLogged()
  user.value = data.nick ?? ''
}

if (pageData.news && String(pageData.news.id) === String(id.value)) {
  applyNews(pageData.news)
}

logado()
if (loading.value) {
  getNews()
}

watch(
  () => route.params.id,
  (newId) => {
    id.value = newId
    getNews()
  },
)
</script>

<template>
  <div class="page news">
    <div class="top">
      <div class="icon"></div>
      <div class="title">
        <span v-if="!loading">{{ titulo }}</span>
        <Sk v-else w="200px" h="16px" extra="my-1" />
      </div>
    </div>
    <div class="content">
      <template v-if="loading">
        <div class="info">
          <Sk w="40px" h="40px" rounded="rounded-full" />
          <Sk w="140px" h="13px" extra="ml-2" />
          <Sk w="80px" h="11px" extra="ml-auto" />
        </div>
        <div class="flex flex-col gap-3 mt-4">
          <Sk w="100%" h="14px" />
          <Sk w="90%" h="14px" />
          <Sk w="95%" h="14px" />
          <Sk w="70%" h="14px" />
          <Sk w="100%" h="200px" rounded="rounded-xl" extra="my-2" />
          <Sk w="100%" h="14px" />
          <Sk w="88%" h="14px" />
          <Sk w="93%" h="14px" />
        </div>
      </template>
      <template v-else>
      <div class="info">
        <div
          class="avatarH"
          :style="{
            backgroundImage: `url('${avatarUrl(autor, { headonly: 1 })}')`,
          }"
        ></div>
        <div
          class="autor grow"
          @click="
            () => {
              showP = true
              perfilName = autor
            }
          "
        >
          Escrito por <span>{{ autor }}</span
          >.
        </div>
        <div class="time">{{ time }}</div>
      </div>
      <div class="text not-tailwind" v-html="text"></div>
      </template>
    </div>
    <ClientOnly>
      <CommentItem v-if="store.logged == 'true' || store.logged" type="news" :id="id" :user="user" />
      <CommentsItem type="news" :id="id" />
      <Transition name="slide-fade">
        <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
      </Transition>
    </ClientOnly>
  </div>
</template>

<style scoped>
.news .top .icon {
  background-color: #21415c;
  background-position: -34px 4px;
}

.news .content :deep(.content) {
  background-color: transparent;
  box-shadow: none;
  width: auto;
  padding: 0;
}

.news .content .info {
  width: 100%;
  height: 48px;
  border-radius: 10px;
  background-color: #f9fafb;
  display: flex;
  justify-content: space-between;
}

.news .content .info .avatarH {
  width: 40px;
  height: 100%;
  background-position: -23px -30px;
  background-repeat: no-repeat;
  margin: 0 0 0 10px;
}

.news .content .info .autor,
.news .content .info .time {
  width: auto;
  height: 20px;
  font-size: 14px;
  margin: 14px 10px 0 10px;
}

.news .content .info .autor span {
  font-weight: 600;
}

.news .content .text {
  width: 100%;
  height: auto;
  margin-top: 20px;
  font-size: 15px;
  color: #050505;
}

.news .content .text :deep(img) {
  border-radius: 4px;
  max-width: 90%;
}
</style>
